export default __webpack_public_path__ + "static/media/image_example_sync.10791cea.svg";